import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueCreatedEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from '.'

export const queueCreated: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_id,
        ...properties
    } = extractProperties<NinchatQueueCreatedEvent>(action.payload)

    if ((state.user_id ?? '') in (properties.queue_members ?? {})) {
        state.user_queues ??= {}

        state.user_queues[queue_id] = properties
    } else {
        state._queues ??= {}

        state._queues[queue_id] = properties
    }
}
